import actions from './actions'
import getters from './getters'
import mutations from './mutations'

interface IState {}

const state: IState = {
  activeTab: ''
}

export default {
  state,
  actions,
  getters,
  mutations
}
